/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * dashboard API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7DashboardsGlobalFilterGetByDashboardIdParams,
  GetV7DashboardsUserFilterGetByDashboardIdParams,
  GlobalFilterResponse,
  IntegrateDashboardGlobalFilterRequest,
  IntegrateDashboardUserFilterAddResponse,
  IntegrateDashboardUserFilterRequest,
  IntegrateDashboardUserFilterV7Response,
  PatchV7DashboardsUserFilterDeleteByDashboardIdParams,
  PostV7DashboardsGlobalFilterByDashboardIdParams,
  PostV7DashboardsUserFilterAddByDashboardIdParams,
  SuccessResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 대시보드 글로벌 필터 update/add/delete
 */
export const postV7DashboardsGlobalFilterByDashboardId = (
  dashboardId: MaybeRef<number>,
  integrateDashboardGlobalFilterRequest: MaybeRef<IntegrateDashboardGlobalFilterRequest>,
  params?: MaybeRef<PostV7DashboardsGlobalFilterByDashboardIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  integrateDashboardGlobalFilterRequest = unref(integrateDashboardGlobalFilterRequest);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/dashboards/${dashboardId}/global-filter`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardGlobalFilterRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7DashboardsGlobalFilterByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DashboardsGlobalFilterByDashboardId>>,
    TError,
    {
      dashboardId: number;
      data: BodyType<IntegrateDashboardGlobalFilterRequest>;
      params?: PostV7DashboardsGlobalFilterByDashboardIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DashboardsGlobalFilterByDashboardId>>,
  TError,
  {
    dashboardId: number;
    data: BodyType<IntegrateDashboardGlobalFilterRequest>;
    params?: PostV7DashboardsGlobalFilterByDashboardIdParams;
  },
  TContext
> => {
  const mutationKey = ['postV7DashboardsGlobalFilterByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DashboardsGlobalFilterByDashboardId>>,
    {
      dashboardId: number;
      data: BodyType<IntegrateDashboardGlobalFilterRequest>;
      params?: PostV7DashboardsGlobalFilterByDashboardIdParams;
    }
  > = (props) => {
    const { dashboardId, data, params } = props ?? {};

    return postV7DashboardsGlobalFilterByDashboardId(dashboardId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DashboardsGlobalFilterByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DashboardsGlobalFilterByDashboardId>>
>;
export type PostV7DashboardsGlobalFilterByDashboardIdMutationBody =
  BodyType<IntegrateDashboardGlobalFilterRequest>;
export type PostV7DashboardsGlobalFilterByDashboardIdMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 글로벌 필터 update/add/delete
 */
export const usePostV7DashboardsGlobalFilterByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DashboardsGlobalFilterByDashboardId>>,
      TError,
      {
        dashboardId: number;
        data: BodyType<IntegrateDashboardGlobalFilterRequest>;
        params?: PostV7DashboardsGlobalFilterByDashboardIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DashboardsGlobalFilterByDashboardId>>,
  TError,
  {
    dashboardId: number;
    data: BodyType<IntegrateDashboardGlobalFilterRequest>;
    params?: PostV7DashboardsGlobalFilterByDashboardIdParams;
  },
  TContext
> => {
  const mutationOptions = getPostV7DashboardsGlobalFilterByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getGlobalFilter
 */
export const getV7DashboardsGlobalFilterGetByDashboardId = (
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsGlobalFilterGetByDashboardIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  params = unref(params);

  return customAxiosInstance<GlobalFilterResponse>(
    {
      url: `/api/v7/dashboards/${dashboardId}/global-filter/get`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7DashboardsGlobalFilterGetByDashboardIdQueryKey = (
  dashboardId?: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsGlobalFilterGetByDashboardIdParams>,
) => {
  return [
    'api',
    'v7',
    'dashboards',
    dashboardId,
    'global-filter',
    'get',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7DashboardsGlobalFilterGetByDashboardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7DashboardsGlobalFilterGetByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsGlobalFilterGetByDashboardIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7DashboardsGlobalFilterGetByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7DashboardsGlobalFilterGetByDashboardIdQueryKey(dashboardId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7DashboardsGlobalFilterGetByDashboardId>>
  > = ({ signal }) =>
    getV7DashboardsGlobalFilterGetByDashboardId(dashboardId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(dashboardId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7DashboardsGlobalFilterGetByDashboardId>>,
    TError,
    TData
  >;
};

export type GetV7DashboardsGlobalFilterGetByDashboardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7DashboardsGlobalFilterGetByDashboardId>>
>;
export type GetV7DashboardsGlobalFilterGetByDashboardIdQueryError = ErrorType<unknown>;

/**
 * @summary getGlobalFilter
 */

export function useGetV7DashboardsGlobalFilterGetByDashboardId<
  TData = Awaited<ReturnType<typeof getV7DashboardsGlobalFilterGetByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsGlobalFilterGetByDashboardIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7DashboardsGlobalFilterGetByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7DashboardsGlobalFilterGetByDashboardIdQueryOptions(
    dashboardId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary addUserFilter
 */
export const postV7DashboardsUserFilterAddByDashboardId = (
  dashboardId: MaybeRef<number>,
  integrateDashboardUserFilterRequest: MaybeRef<IntegrateDashboardUserFilterRequest>,
  params: MaybeRef<PostV7DashboardsUserFilterAddByDashboardIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  integrateDashboardUserFilterRequest = unref(integrateDashboardUserFilterRequest);
  params = unref(params);

  return customAxiosInstance<IntegrateDashboardUserFilterAddResponse>(
    {
      url: `/api/v7/dashboards/${dashboardId}/user-filter/add`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardUserFilterRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7DashboardsUserFilterAddByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DashboardsUserFilterAddByDashboardId>>,
    TError,
    {
      dashboardId: number;
      data: BodyType<IntegrateDashboardUserFilterRequest>;
      params: PostV7DashboardsUserFilterAddByDashboardIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DashboardsUserFilterAddByDashboardId>>,
  TError,
  {
    dashboardId: number;
    data: BodyType<IntegrateDashboardUserFilterRequest>;
    params: PostV7DashboardsUserFilterAddByDashboardIdParams;
  },
  TContext
> => {
  const mutationKey = ['postV7DashboardsUserFilterAddByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DashboardsUserFilterAddByDashboardId>>,
    {
      dashboardId: number;
      data: BodyType<IntegrateDashboardUserFilterRequest>;
      params: PostV7DashboardsUserFilterAddByDashboardIdParams;
    }
  > = (props) => {
    const { dashboardId, data, params } = props ?? {};

    return postV7DashboardsUserFilterAddByDashboardId(dashboardId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DashboardsUserFilterAddByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DashboardsUserFilterAddByDashboardId>>
>;
export type PostV7DashboardsUserFilterAddByDashboardIdMutationBody =
  BodyType<IntegrateDashboardUserFilterRequest>;
export type PostV7DashboardsUserFilterAddByDashboardIdMutationError = ErrorType<unknown>;

/**
 * @summary addUserFilter
 */
export const usePostV7DashboardsUserFilterAddByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DashboardsUserFilterAddByDashboardId>>,
      TError,
      {
        dashboardId: number;
        data: BodyType<IntegrateDashboardUserFilterRequest>;
        params: PostV7DashboardsUserFilterAddByDashboardIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DashboardsUserFilterAddByDashboardId>>,
  TError,
  {
    dashboardId: number;
    data: BodyType<IntegrateDashboardUserFilterRequest>;
    params: PostV7DashboardsUserFilterAddByDashboardIdParams;
  },
  TContext
> => {
  const mutationOptions = getPostV7DashboardsUserFilterAddByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getUserFilter
 */
export const getV7DashboardsUserFilterGetByDashboardId = (
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsUserFilterGetByDashboardIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dashboardId = unref(dashboardId);
  params = unref(params);

  return customAxiosInstance<IntegrateDashboardUserFilterV7Response>(
    {
      url: `/api/v7/dashboards/${dashboardId}/user-filter/get`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7DashboardsUserFilterGetByDashboardIdQueryKey = (
  dashboardId?: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsUserFilterGetByDashboardIdParams>,
) => {
  return [
    'api',
    'v7',
    'dashboards',
    dashboardId,
    'user-filter',
    'get',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7DashboardsUserFilterGetByDashboardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7DashboardsUserFilterGetByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsUserFilterGetByDashboardIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7DashboardsUserFilterGetByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7DashboardsUserFilterGetByDashboardIdQueryKey(dashboardId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7DashboardsUserFilterGetByDashboardId>>
  > = ({ signal }) =>
    getV7DashboardsUserFilterGetByDashboardId(dashboardId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(dashboardId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7DashboardsUserFilterGetByDashboardId>>,
    TError,
    TData
  >;
};

export type GetV7DashboardsUserFilterGetByDashboardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7DashboardsUserFilterGetByDashboardId>>
>;
export type GetV7DashboardsUserFilterGetByDashboardIdQueryError = ErrorType<unknown>;

/**
 * @summary getUserFilter
 */

export function useGetV7DashboardsUserFilterGetByDashboardId<
  TData = Awaited<ReturnType<typeof getV7DashboardsUserFilterGetByDashboardId>>,
  TError = ErrorType<unknown>,
>(
  dashboardId: MaybeRef<number>,
  params?: MaybeRef<GetV7DashboardsUserFilterGetByDashboardIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7DashboardsUserFilterGetByDashboardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7DashboardsUserFilterGetByDashboardIdQueryOptions(
    dashboardId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary deleteUserFilter
 */
export const patchV7DashboardsUserFilterDeleteByDashboardId = (
  dashboardId: MaybeRef<number>,
  params: MaybeRef<PatchV7DashboardsUserFilterDeleteByDashboardIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  dashboardId = unref(dashboardId);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/dashboards/${dashboardId}/user_filter/delete`,
      method: 'PATCH',
      params: unref(params),
    },
    options,
  );
};

export const getPatchV7DashboardsUserFilterDeleteByDashboardIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7DashboardsUserFilterDeleteByDashboardId>>,
    TError,
    { dashboardId: number; params: PatchV7DashboardsUserFilterDeleteByDashboardIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7DashboardsUserFilterDeleteByDashboardId>>,
  TError,
  { dashboardId: number; params: PatchV7DashboardsUserFilterDeleteByDashboardIdParams },
  TContext
> => {
  const mutationKey = ['patchV7DashboardsUserFilterDeleteByDashboardId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7DashboardsUserFilterDeleteByDashboardId>>,
    { dashboardId: number; params: PatchV7DashboardsUserFilterDeleteByDashboardIdParams }
  > = (props) => {
    const { dashboardId, params } = props ?? {};

    return patchV7DashboardsUserFilterDeleteByDashboardId(dashboardId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7DashboardsUserFilterDeleteByDashboardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV7DashboardsUserFilterDeleteByDashboardId>>
>;

export type PatchV7DashboardsUserFilterDeleteByDashboardIdMutationError = ErrorType<unknown>;

/**
 * @summary deleteUserFilter
 */
export const usePatchV7DashboardsUserFilterDeleteByDashboardId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7DashboardsUserFilterDeleteByDashboardId>>,
      TError,
      { dashboardId: number; params: PatchV7DashboardsUserFilterDeleteByDashboardIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7DashboardsUserFilterDeleteByDashboardId>>,
  TError,
  { dashboardId: number; params: PatchV7DashboardsUserFilterDeleteByDashboardIdParams },
  TContext
> => {
  const mutationOptions = getPatchV7DashboardsUserFilterDeleteByDashboardIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
